import profilePicture from "../assets/images/profile_picture.png";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-family: "Cormorant Garamond", serif;
  font-weight: 500;
  font-style: normal;

  .pic img {
    height: 700px;
  }

  .info ul {
    list-style: none;
    padding-left: 0;
    margin-top: 200px;

    @media (max-width: 1200px) {
      margin: 170px 0 170px 0;
    }
}

  .info li {
    &:not(:last-child) {
      margin: 0 0 40px 0;
    }
  }

  @media (max-width: 1200px) {
    display: flex;
    flex-direction: column;

    li {
      align-items: center;
    }

    img {
      object-fit: cover;
      width: 100%;
    }
  }
`;

const StyledNavLink = styled.a`
  color: #233a67;
  text-decoration: none;
`;

const Content = styled.div<{ $justifyText?: boolean }>`
  padding: 0 3em;
  text-align: ${(props) => (props.$justifyText ? "justify" : "center")};
  font-size: 1.1em;
  line-height: 1.8em;
`;

const items = [
  {
    title: "Bio",
    content: (
      <>
        <p>
        Hello, and thank you for visiting my website! <br />
        My name is Ai, and I'm a Software Engineer based in London.
        </p>
        <p>
        I studied Computer Science at the University of Tsukuba,
        where I wrote my bachelor's thesis on NLP and developed several web applications. <br />
        You can find some of the projects I've worked on in the{" "}
          <StyledNavLink href="#portfolio">Portfolio</StyledNavLink> section as
          well as on my{" "}
          <StyledNavLink href="https://github.com/aimiyuki" target="_blank">
            GitHub
          </StyledNavLink>
          .
        </p>
      </>
    ),

    justify: true,
  },
];

function Profile() {
  return (
    <Container>
      <div className="pic">
        <img src={profilePicture} alt="profile" />
      </div>
      <div className="info">
        <ul>
          {items.map((item, index) => {
            return (
              <li key={index}>
                <h3>{item.title}</h3>
                <Content $justifyText={item.justify}>{item.content}</Content>
              </li>
            );
          })}
        </ul>
      </div>
    </Container>
  );
}

export default Profile;
